import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Carousel, Container } from '@pella/sash-framework';
import { CTA } from '../../';
import { monetateDataLayer, setBackgroundColor } from '../../utilities/functions';
import { isValidArray } from '../../utilities/validations';

import ResultsTile from '../../../templates/plp/results/tile';
import styles from './index.module.scss';

const EcomCardSlider = ({ data, dynamic, className, pdpURL }) => {
	useEffect(() => {
		if (isValidArray(dynamic?.manual_entries)) {
			const tileArr = dynamic.manual_entries.map((item) => item.backend_name);
			monetateDataLayer('addProducts', tileArr);
		}
	}, [dynamic]);

	if (!isValidArray(dynamic.manual_entries)) return null;

	return (
		<div
			id={data.anchor_text || null}
			className={`${styles.ecomCardSlider} ${data.background_color ? styles[setBackgroundColor(data.background_color)] : ''} ${className || ''}`}
		>
			{(data.heading || data.subheading) && (
				<Container>
					{data.heading && <h2 className='mb-4 md:mb-6'>{data.heading}</h2>}
					{data.subheading && <p className='text-subtitle mb-4'>{data.subheading}</p>}
				</Container>
			)}

			<div className={styles.ecomCardSlider_Wrapper}>
				<Container>
					<Carousel
						className='ecomCardSlider py-2.5'
						arrowsClassName='max-md:hidden'
						slidesToShow={{ xs: 1, md: 2, xl: 3 }}
						slidePadding={20}
						showArrows
						showDots
					>
						{isValidArray(dynamic.manual_entries) &&
							dynamic.manual_entries
								.filter((item) => pdpURL !== item.static_url)
								.map((tile, index) => (
									<div
										key={index}
										className={styles.ecomCardSlider_Slide}
									>
										<ResultsTile
											tile={tile}
											pdpURL={tile.static_url || null}
										/>
									</div>
								))}
					</Carousel>
				</Container>
			</div>

			{isValidArray(dynamic.ctas) && (
				<div className={styles.ecomCardSlider_BtnWrapper}>
					<Container>
						<CTA data={dynamic.ctas[0]} />
					</Container>
				</div>
			)}

			<noscript
				dangerouslySetInnerHTML={{
					__html: `<style>.ecom-card-slider--ecomCardSlider_Slide { opacity: 1 !important; }</style>`,
				}}
			/>
		</div>
	);
};

EcomCardSlider.propTypes = {
	data: PropTypes.object,
	dynamic: PropTypes.object,
	background: PropTypes.bool,
	className: PropTypes.string,
	pdpURL: PropTypes.string,
};

export default EcomCardSlider;
